import { render, staticRenderFns } from "./teacherMissingTab.vue?vue&type=template&id=c519c91e&"
import script from "./teacherMissingTab.vue?vue&type=script&lang=js&"
export * from "./teacherMissingTab.vue?vue&type=script&lang=js&"
import style0 from "./teacherMissingTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports